import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";
import MainInput from "components/MainApp/atoms/Forms/MainInput";


import styles from "./LoadBusiness.Wizard.Step2.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export class AddConfigTagStepTwo extends React.Component {
  render() {
    const { business, handleChange, goBack, handleContinue, enableContinue, error } = this.props;
    const stepContent = (
      <form onSubmit={handleContinue}>
      <div className={styles["add-config-tag-wizard-step-two-content"]}>
        <div className={styles["add-config-tag-wizard-step-two-field"]} data-automation-id="input-address">
          <MainInput
            label={capitalize(i18n.t("address"))}
            required={false}
            id={"business-address"}
            name="address"
            value={business ? business.address : ''}
            handleChange={handleChange}
            maxLength={100}
            error={error.address && error.address}
            />
        </div>
        <div className={styles["add-config-tag-wizard-step-two-field"]} data-automation-id="input-phone">
          <MainInput
              label={i18n.t("phone")}
              required={true}
              id={"business-phone"}
              name="phone"
              value={business ? business.phone : ''}
              handleChange={handleChange}
              maxLength={100}
              error={error.phone && error.phone}

            />
        </div>
        <div className={styles["add-config-tag-wizard-step-two-field"]} data-automation-id="input-email">
          <MainInput
              label={i18n.t("email")}
              required={true}
              id={"business-email"}
              name="email"
              value={business ? business.email : ''}
              handleChange={handleChange}
              maxLength={100}
              error={error.email && error.email}

            />
        </div>
        <div className={styles["add-config-tag-wizard-step-two-action-wrapper"]}>
          <button type="submit" className={`${styles["add-config-tag-wizard-step-two-action-button"]} ${!enableContinue && 'disabled'}`} onClick={enableContinue ? handleContinue : undefined} >
            {i18n.t("continue").toUpperCase()}
          </button>
        </div>
      </div>
      </form>
    );

    return (
      <div className={styles["add-config-tag-wizard-step-two-container"]}>
        <Step title={i18n.t("add.contact.info")} goBackFunc={goBack} content={stepContent}></Step>
      </div>
    );
  }
}

export default AddConfigTagStepTwo;
